export class ProgressMessageModel {
  task: string;
  message: string;
}
